import BaseMystery from '../BaseMystery'

const ThirdSorrow = () => {
	const imagesList = [
		"https://www.meisterdrucke.ie/kunstwerke/1260px/Harold%20Copping%20-%20My%20fathers%20business%20-%20%28MeisterDrucke-279308%29.jpg",
	];

	const titleText = "The Loss of Jesus in the Temple";
	const scriptureQuote = "\"Son, why have you done this to us? Your father and I have been looking for you with great anxiety.\"";
	const scriptureCitation = "Luke 2:48 (NABRE)";
	const citationLink = "https://www.biblegateway.com/passage/?search=Luke%202%3A41-52&version=NABRE";

	return (
		<BaseMystery titleText={titleText}
				imagesList={imagesList}
				scriptureQuote={scriptureQuote}
				scriptureCitation={scriptureCitation}
				citationLink={citationLink}
				rightHanded={false} />
	);
};

export default ThirdSorrow;